import { createAction, Dispatch } from '@reduxjs/toolkit';
import { CommitModel } from '../../models/commitModel';
import CommitApi from '../../api/commitApi';
import { AppError } from '../../types/appError';

export const commitsFetchOneRequestAction = createAction<void>('commits/fetchOneRequest');
export const commitsFetchOneSuccessAction = createAction<CommitModel>('commits/fetchOneSuccess');
export const commitsFetchOneFailureAction = createAction<AppError>('commits/fetchOneFailure');

export const fetchCommitIfNotExisting = (commitId: string) => async (dispatch: Dispatch) => {
  dispatch(commitsFetchOneRequestAction);
  try {
    const oneCommit = await CommitApi.fetchCommitById(commitId);
    dispatch(commitsFetchOneSuccessAction(oneCommit));
  } catch (error) {
    dispatch(commitsFetchOneFailureAction(error as AppError));
  }
}
